import {withinPeriod} from 'core/Record';
import {periodOf} from 'core/Budget';

function decreaseSpentBy(budget: Budget, difference: MoneyAmount): Budget {
  const spent = budget.spent - difference;
  return {...budget, spent};
}

function increaseBudgetBy(budget: Budget, difference: MoneyAmount): Budget {
  const initial = budget.initial + difference;
  return {...budget, initial};
}

export function deleteSpend(budget: Budget, spend: RecordEntry): Budget {
  const madeDuringPeriod = withinPeriod(spend, periodOf(budget));
  return madeDuringPeriod
    ? decreaseSpentBy(budget, spend.amount)
    : increaseBudgetBy(budget, spend.amount);
}
